import React from 'react';
import { AppBar, Toolbar, Button, IconButton, Tooltip } from '@mui/material';
import { FaChartBar, FaUsers, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase'; // Import Firebase auth
import logo from '../assets/img/logo_primary.svg';
import './adminDashboard.css';


const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await auth.signOut(); // Sign out the user using Firebase Authentication
      navigate('/login'); // Redirect to the login page after logout
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const isActive = (path) => location.pathname === path;
  const navItems = [
    { label: 'Waitlist', path: '/waitlist-dashboard', icon: <FaChartBar /> },
    { label: 'Brand Ambassadors', path: '/brand-ambassador-dashboard', icon: <FaUsers /> },
    { label: 'Profile', path: '/profile', icon: <FaUserCircle /> },
  ];

  return (
    <AppBar position="fixed" className="admin-navbar">
      <Toolbar className="admin-navbar__toolbar">
        <div className="admin-navbar__brand">
          <img src={logo} alt="99 Yards" className="admin-navbar__logo" />
          <div>
            <div className="admin-navbar__title">99 Yards</div>
            <div className="admin-navbar__subtitle">Admin Dashboard</div>
          </div>
        </div>

        <div className="admin-navbar__links">
          {navItems.map((item) => (
            <Button
              key={item.path}
              className={`admin-navbar__link ${isActive(item.path) ? 'admin-navbar__link--active' : ''}`}
              startIcon={item.icon}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </Button>
          ))}
          <Tooltip title="Logout">
            <IconButton onClick={handleLogout} className="admin-navbar__logout" aria-label="Logout">
              <FaSignOutAlt />
            </IconButton>
          </Tooltip>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
